module.exports = __webpack_public_path__ + "static/8-40f70e19400cefc7528bbcc5631efe06.jpg";